import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { ApplicationModes } from '../../constants/application-modes';
import ApplicationModeSpecificComponent from '../application-mode-specific-component';
import { ResultState } from '../result-state';

import LandingDark from './assets/landing-dark.svg';
import LandingLight from './assets/landing-light.svg';
import { messages } from './messages';

const styles = cssMap({
	headingWrapper: {
		font: token('font.heading.medium'),
		fontWeight: token('font.weight.medium'),
	},
});

const getMessage = (isAIEnabled: boolean) =>
	isAIEnabled ? messages.landingSecondaryWithAI : messages.landingSecondary;

export type SecondaryTextProps = {
	applicationMode: ApplicationModes;
	isAdminHubAIEnabled?: boolean;
	isRovoLLMEnabled?: boolean;
};

const SecondaryText = ({
	applicationMode,
	isAdminHubAIEnabled = false,
	isRovoLLMEnabled = false,
}: SecondaryTextProps) => {
	if (fg('rovo_search_updated_entitlement_checks_for_team_25')) {
		return (
			<ApplicationModeSpecificComponent
				rovoComponent={<FormattedMessage {...getMessage(isRovoLLMEnabled)} />}
				unifiedComponent={<FormattedMessage {...getMessage(isAdminHubAIEnabled)} />}
				applicationMode={applicationMode}
			/>
		);
	}

	return (
		<ApplicationModeSpecificComponent
			rovoComponent={<FormattedMessage {...messages.landingSecondaryRovo} />}
			unifiedComponent={
				isAdminHubAIEnabled ? (
					<FormattedMessage {...messages.landingSecondaryUnifiedWithSAIN} />
				) : (
					<FormattedMessage {...messages.landingSecondaryUnifiedWithoutSAIN} />
				)
			}
			applicationMode={applicationMode}
		/>
	);
};

export const Landing = (props: SecondaryTextProps): React.JSX.Element => {
	return (
		<ResultState
			testId="search-page-landing"
			imageSrcLight={LandingLight}
			imageSrcDark={LandingDark}
			primaryText={
				<Box xcss={styles.headingWrapper} as="h2">
					<FormattedMessage {...messages.landingPrimary} />
				</Box>
			}
			secondaryText={<SecondaryText {...props} />}
		/>
	);
};
